import type { FindContractSpecialsItem } from "@zhihaoscm/entity";
import type { Officer } from "@/views/components/AssignDialog/AssignDialog";

/** 将专区合同专员接口转换为公共指派弹框所需的卡片数据。 */
export type ZoneContractAssignOfficer = Officer & {
    orderCount: number;
};

/** 统一使用 personId 作为指派值，避免误把用户记录 id 当成专员 id。 */
export function mapContractSpecialsToOfficers(items: FindContractSpecialsItem[]): ZoneContractAssignOfficer[] {
    return items.map(item => ({
        user: {
            personId: item.user?.personId ?? item.personId,
            name: item.user?.name,
            employeeId: item.user?.employeeId
        },
        orderCount: item.contractCount
    }));
}
